import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/dataScreen',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'dataScreen', name: 'DataScreen', meta: { name: '数据可视化大屏' }, component: () => import('../views/manager/DataScreen') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'merchantManage', name: 'MerchantManage', meta: { name: '商家信息管理' }, component: () => import('../views/manager/Merchant') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'feedback', name: 'NoticeFeedback', meta: { name: '用户反馈' }, component: () => import('../views/manager/NoticeFeedback') },
      { path: 'product', name: 'ManagerProduct', meta: { name: '产品信息管理' }, component: () => import('../views/manager/Product') },
      { path: 'order', name: 'PlatformOrder', meta: { name: '平台订单管理' }, component: () => import('../views/manager/Order') },
      { path: 'scienceContent', name: 'ScienceContent', meta: { name: '科普内容管理' }, component: () => import('../views/manager/ScienceContent') },
      { path: 'recommendApply', name: 'RecommendApply', meta: { name: '推荐位审核' }, component: () => import('../views/manager/RecommendApply') },
      { path: 'recommendRule', name: 'RecommendRule', meta: { name: '智能推荐规则' }, component: () => import('../views/manager/RecommendRules') },
      { path: 'rules', name: 'Rules', meta: { name: '平台规则' }, component: () => import('../views/manager/Rules') }, 
      { path: 'productRelationAudit', name: 'ProductContent', meta: { name: '产品关联审核' }, component: () => import('../views/manager/ProductContent') },
      { path: 'orderArbitration', name: 'OrderArbitration', meta: { name: '订单仲裁管理' }, component: () => import('../views/manager/OrderArbitration') },
      { path: 'staff', name: 'Staff', meta: { name: '专业人员管理' }, component: () => import('../views/manager/Staff.vue') },
      { path: 'consultation', name: 'Consultation', meta: { name: '专家咨询管理' }, component: () => import('../views/manager/Consultation') },
    ]
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: () => import('../views/Merchant.vue'),
    redirect: '/merchant/home',
    children: [
      { path: 'home', name: 'MerchantHome', meta: { name: '系统首页' }, component: () => import('../views/merchant/Home.vue') },
      { path: 'shopInfo', name: 'ShopInfo', meta: { name: '账号与店铺管理' }, component: () => import('../views/merchant/ShopInfo.vue') },
      { path: 'product', name: 'Product', meta: { name: '产品管理中心' }, component: () => import('../views/merchant/Product.vue') },
      { path: 'order', name: 'MerchantOrder', meta: { name: '订单管理中心' }, component: () => import('../views/merchant/Order.vue') },
      { path: 'statistics', name: 'Statistics', meta: { name: '数据统计与分析' }, component: () => import('../views/merchant/Statistics.vue') },
      { path: 'marketing', name: 'Marketing', meta: { name: '产品营销' }, component: () => import('../views/merchant/Marketing.vue') },
      { path: 'person', name: 'MerchantPerson', meta: { name: '个人信息' }, component: () => import('../views/merchant/Person.vue') },
      { path: 'password', name: 'MerchantPassword', meta: { name: '修改密码' }, component: () => import('../views/merchant/Password.vue') },
      { path: 'staff', name: 'MerchantStaff', meta: { name: '专业人员管理' }, component: () => import('../views/manager/Staff.vue') },
      { path: 'scienceAudit', name: 'ScienceAudit', meta: { name: '科普文章审核' }, component: () => import('../views/merchant/ScienceAudit.vue') },
      { path: 'comment', name: 'MerchantComment', meta: { name: '评价管理' }, component: () => import('../views/merchant/Comment.vue') },
      { path: 'rules', name: 'MerchantRules', meta: { name: '平台规则' }, component: () => import('../views/merchant/Rules.vue') },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'FrontHome', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人中心' }, component: () => import('../views/front/Person') },
      { path: 'brand', name: 'Brand', meta: { name: '品牌中心' }, component: () => import('../views/front/Brand') },
      { path: 'resource', name: 'Resource', meta: { name: '资源中心' }, component: () => import('../views/front/Resource') },
      { path: 'service', name: 'Service', meta: { name: '个性化服务' }, component: () => import('../views/front/Service') },
      { path: 'science', name: 'Science', meta: { name: '视光科普' }, component: () => import('../views/front/Science') },
      { path: 'proContent', name: 'ProContent', meta: { name: '科普发布' }, component: () => import('../views/front/ProContent') },
      { path: 'scienceDetail', name: 'ScienceDetail', meta: { name: '科普文章详情' }, component: () => import('../views/front/ScienceDetail') },
      { path: 'proApply', name: 'ProApply', meta: { name: '专家认证' }, component: () => import('../views/front/ProApply') },
      { path: 'expert', name: 'ExpertList', meta: { name: '找专家' }, component: () => import('../views/front/ExpertList') },
      { path: 'myConsultation', name: 'MyConsultation', meta: { name: '我的咨询' }, component: () => import('../views/front/MyConsultation') },
      { path: 'shop', name: 'FrontShop', meta: { name: '商家店铺' }, component: () => import('../views/front/Shop') },
      { path: 'productDetail', name: 'ProductDetail', meta: { name: '产品详情' }, component: () => import('../views/front/ProductDetail') },
      { path: 'chat', name: 'Chat', meta: { name: '在线消息' }, component: () => import('../views/front/Chat') },
      { path: 'orders', name: 'Orders', meta: { name: '我的订单' }, component: () => import('../views/front/Orders') },
      { path: 'cart', name: 'Cart', meta: { name: '购物车' }, component: () => import('../views/front/Cart') },
      { path: 'collect', name: 'Collect', meta: { name: '我的收藏' }, component: () => import('../views/front/Collect') },
      { path: 'coupons', name: 'Coupons', meta: { name: '优惠券' }, component: () => import('../views/front/Coupons') },
      { path: 'afterSale', name: 'AfterSale', meta: { name: '售后服务' }, component: () => import('../views/front/AfterSale') },
      { path: 'comments', name: 'Comments', meta: { name: '我的评价' }, component: () => import('../views/front/Comments') },
      { path: 'profile', name: 'Profile', meta: { name: '基本资料' }, component: () => import('../views/front/Profile') },
      { path: 'healthArchive', name: 'HealthArchive', meta: { name: '健康档案' }, component: () => import('../views/front/HealthArchive') },
      { path: 'personalizedService', name: 'PersonalizedService', meta: { name: '个性化服务' }, component: () => import('../views/front/PersonalizedService') },
      { path: 'security', name: 'Security', meta: { name: '账号安全' }, component: () => import('../views/front/Security') },
      { path: 'merchantInfo', name: 'MerchantInfo', meta: { name: '所属商家' }, component: () => import('../views/front/MerchantInfo') },
      { path: 'visionTest', name: 'VisionTest', meta: { name: '视力小测试' }, component: () => import('../views/front/VisionTest') },
      { path: 'prescription', name: 'Prescription', meta: { name: '专业验光单管理' }, component: () => import('../views/front/Prescription') },
      { path: 'eyeCare', name: 'EyeCare', meta: { name: '护眼打卡' }, component: () => import('../views/front/EyeCare') },
      { path: 'aiTryOn', name: 'AiTryOn', meta: { name: 'AI智能选镜' }, component: () => import('../views/front/AiTryOn') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '/reRegister', name: 'ReRegister', meta: { name: '重新申请' }, component: () => import('../views/ReRegister.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
  const whiteList = ['/login', '/register', '/403', '/reRegister']

  // 如果访问白名单页面，直接放行
  if (whiteList.includes(to.path)) {
    return next();
  }

  // 关键：每次路由跳转都去后端验证Token有效性，并同步最新用户信息
  if (user.token) {
    try {
      const res = await axios.get(process.env.VUE_APP_BASEURL + '/getAccount', {
        headers: { token: user.token }
      })
      if (res.data.code === '200' && res.data.data && res.data.data.id) {
        // 后端验证通过，更新本地缓存的用户信息（覆盖可能的篡改）
        const freshUser = res.data.data
        freshUser.token = user.token // 保持Token
        localStorage.setItem('xm-user', JSON.stringify(freshUser))
        user = freshUser // 更新当前变量，供后续逻辑使用
      } else {
        // Token无效或过期，清除缓存并跳转登录
        localStorage.removeItem('xm-user')
        if (!to.path.startsWith('/front')) {
           return next('/login')
        }
        // 如果是前台页面，允许以游客身份访问（清除user后继续）
        user = {}
      }
    } catch (e) {
      console.error('Session validation failed', e)
      localStorage.removeItem('xm-user')
      if (!to.path.startsWith('/front')) {
         return next('/login')
      }
      user = {}
    }
  }

  // 根路径特殊处理：根据角色引导
  if (to.path === '/') {
    if (!user.id) {
      return next('/login');
    }
    if (user.role === 'ADMIN') {
      return next('/dataScreen');
    } else if (user.role === 'MERCHANT') {
      return next('/merchant/home');
    } else {
      return next('/front/home');
    }
  }

  // 如果访问前台页面，直接放行
  if (to.path.startsWith('/front')) {
    return next();
  }

  // 如果未登录且访问受限页面，跳转到登录页
  if (!user.id) {
    return next('/login');
  }

  // 已登录，根据角色检查权限
  const role = user.role;
  
  // 商家相关路由权限检查
  if (to.path === '/merchant' || to.path.startsWith('/merchant/')) {
    if (role === 'MERCHANT' || role === 'ADMIN') {
      return next();
    } else {
      return next('/403');
    }
  }

  // 管理后台相关路由权限检查
  // 注意：除前台、商家后台、白名单之外的路由，均视为管理后台路由
  if (!to.path.startsWith('/front') && !(to.path === '/merchant' || to.path.startsWith('/merchant/'))) {
    if (role === 'ADMIN') {
      return next();
    } else {
      // 非管理员账号，跳转到其对应主页
      if (role === 'MERCHANT') {
        return next('/merchant/home');
      } else {
        return next('/front/home');
      }
    }
  }

  next();
})

export default router
